module.exports = __webpack_public_path__ + "static/hero-background-be0b452accf1b11688138a026ef06c35.jpeg";